import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { BcacSelectGroupComponent } from './bcac-select-group.component'
import { NzToolTipModule } from 'ng-zorro-antd';


@NgModule({
  declarations: [BcacSelectGroupComponent],
  imports: [
    CommonModule,
    NzSelectModule,
    FormsModule,
    NzToolTipModule
  ],
  exports: [BcacSelectGroupComponent]
})
export class BcacSelectGroupModule { }
